import { fetcher } from '../utils'
import { ComponentClientProfileVO, FromProductClientProfileVO } from '@repo/types'

export default async (input: ComponentClientProfileVO): Promise<FromProductClientProfileVO> =>
  fetcher(`/api/relationship/client/profile`, 'POST', input)
